import { ws } from "../../utils/common";

export const getAssociationsStatsWS = async ({ start, end }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "association/",
    { start: start && end ? start : null, end: start && end ? end : null },
    null,
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};
